import * as React from "react";

import type { GameLibraryAdapter } from "./adapter.ts";

const AdapterContext = React.createContext<GameLibraryAdapter | null>(null);

export const GameLibraryAdapterProvider: React.FC<{
  adapter: GameLibraryAdapter;
  children: React.ReactNode;
}> = ({ adapter, children }) => (
  <AdapterContext.Provider value={adapter}>{children}</AdapterContext.Provider>
);

export function useGameLibraryAdapter(): GameLibraryAdapter {
  const ctx = React.useContext(AdapterContext);
  if (!ctx) {
    throw new Error(
      "useGameLibraryAdapter must be used inside <GameLibraryAdapterProvider> — wrap <GameLibrary /> with the adapter provider at the route boundary.",
    );
  }
  return ctx;
}
